/* eslint-disable @typescript-eslint/no-explicit-any */
const isObject = (value: any) => typeof value === "object" && value !== null && !Array.isArray(value);

export default isObject;
